import { render, staticRenderFns } from "./diyReportDetail.vue?vue&type=template&id=134f038c&scoped=true"
import script from "./diyReportDetail.vue?vue&type=script&lang=js"
export * from "./diyReportDetail.vue?vue&type=script&lang=js"
import style0 from "./diyReportDetail.vue?vue&type=style&index=0&id=134f038c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f038c",
  null
  
)

export default component.exports